import { gql } from '@apollo/client';

export const blockFragments = {
  blockItem: gql`
    fragment BlockItem on Block {
      id
      projectId
      parentId
      tag
      sequenceNumber
      vendorSide
      isBreaker
      isDefined
      updatedTime
      updatedBy
      blockPoints {
        id
        projectId
        blockId
        tag
        sequenceNumber
        vendorSide
        breakerSizeAmps
        connectedLoad
        gangSequence
        description
        revision
        isDefined
        updatedTime
        updatedBy
        equipmentBlockPointView {
          id
          vendorCount
          customerCount
        }
      }
    }
  `,
};

export const GET_BLOCKS_BY_COMMODITY = gql`
  ${blockFragments.blockItem}
  query BlocksByCommodity($commodityId: ID!, $blockCommodityType: BlockCommodityType!) {
    blocksByCommodity(commodityId: $commodityId, blockCommodityType: $blockCommodityType) {
      ...BlockItem
    }
  }
`;

export const GET_BLOCK_POINTS_BY_EQUIPMENTS = gql`
  query BlockPointsByEquipmentIds($equipmentIds: [ID!]!) {
    blockPointsByEquipmentIds(equipmentIds: $equipmentIds) {
      id
      pointTag
      blockId
      blockTag
      equipmentId
      equipmentTag
      vendorCount
      customerCount
    }
  }
`;

export const SAVE_EQUIPMENT_BLOCKS = gql`
  ${blockFragments.blockItem}
  mutation saveBlocks($saveBlockInput: SaveBlockInput!) {
    saveBlocks(saveBlockInput: $saveBlockInput) {
      errors
      infos
      blocks {
        ...BlockItem
      }
    }
  }
`;

export const GET_BREAKER_PANELS = gql`
  query BreakerPanels($breakerPanelInput: BreakerPanelInput!) {
    breakerPanels(breakerPanelInput: $breakerPanelInput) {
      blockId
      cableId
      description
      facility
      gangSequence
      pointId
      toEquipmentId
      equipmentId
      isScheduled
      cableTag
      toEquipmentTag
      pointSequence
      breakerSizeAmps
      connectedLoad
      breakerRev
    }
  }
`;

export const SEARCH_BLOCK = gql`
  ${blockFragments.blockItem}
  query SearchBlocks($searchInput: SearchInput, $blockCommodityType: BlockCommodityType!) {
    searchBlocks(searchInput: $searchInput, blockCommodityType: $blockCommodityType) {
      items {
        ...BlockItem
      }
    }
  }
`;
